import ReportingSubLinks from '../../components/header/ReportingSubLinks.jsx';
import BackArrow from '../../components/common/BackArrow.jsx';
import LicenseDataForm from '../../components/reporting/LicenseDataForm.jsx';

/**
 * Component for rendering the page for license reporting data.
 * @returns {JSX.Element} LicenseReportingDataPage component.
 */
const LicenseReportingDataPage = () => {
    return (
        <div>
            <ReportingSubLinks />
            <div className="newsc-container">
                <br />
                <br />
                <br />
                <div className="create-office-heading">
                    <BackArrow navigateTo={-1} />
                    <h2>TSPlus Licenses Query</h2>
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100vh',
                        width: '100%'
                    }}>
                    <LicenseDataForm />
                </div>
            </div>
        </div>
    );
};

export default LicenseReportingDataPage;
